import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SharedNavScrollDirective} from './shared-nav-scroll.directive';
import {ContentOffsetDirective} from './content-offset.directive';

@NgModule({
  declarations: [
    SharedNavScrollDirective,
    ContentOffsetDirective
  ],
  imports: [CommonModule],
  exports: [
    SharedNavScrollDirective,
    ContentOffsetDirective
  ]
})
export class SharedNavModule {}